// extracted by mini-css-extract-plugin
export default {"currency-option":"CurrencySelect_currency-option__TKah-","currency":"CurrencySelect_currency__Q4+FS"};